<template>
  <v-dialog :value="value" @input="$emit('input', $event)" max-width="60vw">
    <v-card>
      <v-card-title>
        <span class="headline">申請を取り消しますが、よろしいですか？</span>
      </v-card-title>
      <v-card-text>
        ※
        予算の削除をご希望される場合、「削除申請」から申請後、承認されるまでお待ち下さい。
      </v-card-text>
      <v-card-actions>
        <v-spacer />
        <v-btn @click="cancelRequest" color="primary">申請を取り消す</v-btn>
        <v-btn @click="$emit('input', false)">キャンセル</v-btn>
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>

<script>
export default {
  name: 'CancelRequestModal',
  props: {
    value: Boolean,
    latestRequest: {
      type: Object,
      require: false,
      default: () => {},
    },
    canEdit: Boolean,
  },
  methods: {
    async cancelRequest() {
      this.$emit('cancelRequest', this.latestRequest)
    },
  },
}
</script>

<style scoped lang="scss">
.label {
  font-size: 12px;
  color: rgba(0, 0, 0, 0.54);
}

.value {
  font-size: 16px;

  &.is-new {
    color: #999999;
  }
}
</style>
